import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=21974d29&scoped=true&lang=html"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=21974d29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21974d29",
  null
  
)

export default component.exports